module.exports = __webpack_public_path__ + "static/media/hero-banner.e0a4e711.svg";